export class LoginRadiusApiClient {
    constructor(
        private apiKey: string,
        private jwtApp: string,
        private accessToken: string
        ) {
    }

    /**
     * Get profile from access token
     * https://www.loginradius.com/docs/api/v2/customer-identity-api/authentication/auth-read-profiles-by-token/
     *
     * @return {Promise<any>} profile
     */
     public async getProfile(): Promise<any> {
        // tslint:disable-next-line: max-line-length
        const profileResponse = await fetch(`https://api.loginradius.com/identity/v2/auth/account?apiKey=${this.apiKey}&access_token=${this.accessToken}`, {
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            method: 'GET'
        })

        const profile = await profileResponse.json()

        if (profile.ErrorCode) {
            throw new Error(profile.Description)
        }

        return profile
    }

    /**
     * Get JWT token from access token
     * https://www.loginradius.com/docs/api/v2/single-sign-on/federated-sso/jwt-login/jwt-token/
     *
     * @return {Promise<string>} JWT token
     */
    public async getJwtToken(): Promise<string> {
        // tslint:disable-next-line: max-line-length
        const jwtTokenResponse = await fetch(`https://cloud-api.loginradius.com/sso/jwt/api/token?apiKey=${this.apiKey}&jwtapp=${this.jwtApp}&access_token=${this.accessToken}`, {
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            method: 'GET'
        })

        const response = await jwtTokenResponse.json()

        if (response.ErrorCode) {
            throw new Error(response.Description)
        }

        return response.signature
    }

    /**
     * Validate the access token
     * https://www.loginradius.com/docs/api/v2/customer-identity-api/authentication/auth-validate-access-token/
     *
     * @returns {Promise<boolean>} token valid flag
     */
     public async validateAccessToken(): Promise<boolean> {
        // tslint:disable-next-line: max-line-length
        const validateTokenCall = await fetch(`https://api.loginradius.com/identity/v2/auth/access_token/Validate?apiKey=${this.apiKey}`, {
            headers: {
                'Authorization': `Bearer ${this.accessToken}`,
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            method: 'GET'
        })

        const response = await validateTokenCall.json()

        return !!response.access_token
    }

    /**
     * Invalidate the access token
     * https://www.loginradius.com/docs/api/v2/customer-identity-api/authentication/auth-invalidate-access-token/
     *
     */
     public async invalidateAccessToken() {
        // tslint:disable-next-line: max-line-length
        await fetch(`https://api.loginradius.com/identity/v2/auth/access_token/inValidate?apiKey=${this.apiKey}`, {
            headers: {
                'Authorization': `Bearer ${this.accessToken}`,
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            method: 'GET'
        })
    }
}
